var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 12,
    viewBox: "0 0 4 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875008 10.4234C0.876 10.7021 0.973549 10.972 1.15106 11.1869C1.32857 11.4019 1.57507 11.5487 1.84864 11.6024C2.1222 11.6561 2.40591 11.6134 2.65152 11.4815C2.89712 11.3496 3.08943 11.1366 3.19574 10.8789C3.30205 10.6212 3.31578 10.3346 3.23461 10.0679C3.15343 9.80122 2.98236 9.57088 2.75049 9.41609C2.51863 9.26131 2.2403 9.19163 1.96286 9.21893C1.68542 9.24622 1.426 9.3688 1.22875 9.56581C1.11609 9.67832 1.02684 9.81202 0.966121 9.95921C0.905408 10.1064 0.874441 10.2641 0.875008 10.4234ZM1.47744 7.60952H2.68337C2.73663 7.60952 2.78773 7.58843 2.82549 7.55087C2.86325 7.51331 2.88461 7.46233 2.88489 7.40906V0.575453C2.88461 0.522376 2.8634 0.471554 2.82587 0.434022C2.78834 0.396491 2.73752 0.375282 2.68444 0.375H1.47744C1.42418 0.375283 1.37319 0.39664 1.33563 0.434403C1.29807 0.472165 1.27698 0.523262 1.27698 0.576525V7.41014C1.27755 7.46303 1.29888 7.51358 1.33638 7.55088C1.37388 7.58818 1.42455 7.60924 1.47744 7.60952Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.0e63d00d.svg";
export { ForwardRef as ReactComponent };